import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ESignRoutingModule } from './e-sign-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { UiModule } from 'src/app/shared/ui/ui.module';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgStepperModule } from 'angular-ng-stepper';


import { SendDocumentComponent } from './send-document/send-document.component';
import { MyDocumentComponent } from './my-document/my-document.component';
import { ESignDashboardComponent } from './e-sign-dashboard/e-sign-dashboard.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { WidgetModule } from 'src/app/shared/widget/widget.module';


@NgModule({
  declarations: [
    SendDocumentComponent,
    MyDocumentComponent,
    ESignDashboardComponent

  ],
  imports: [
    CommonModule,
    ESignRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    TableModule,
    InputTextModule,
    DropdownModule,
    CalendarModule,
    UiModule,
    CdkStepperModule,
    NgApexchartsModule,
    NgStepperModule,
    WidgetModule
  ],
  exports: [
    ESignDashboardComponent
  ]
})
export class ESignModule { }
